<!-- @format -->

<template>
  <div class="ui sixteen column grid centered">
    <div class="five wide column" style="padding: 1em 0em 0em 2em">
      <div class="ui small secondary pointing menu">
        <a
          class="item"
          v-bind:class="{ active: tabLeft == 1 }"
          @click.prevent="tabLeft = 1"
          >Client</a
        >
        <a
          class="item"
          v-bind:class="{ active: tabLeft == 6 }"
          @click.prevent="tabLeft = 6"
          >Goal</a
        >
        <a
          class="item"
          v-bind:class="{ active: tabLeft == 2 }"
          @click.prevent="tabLeft = 2"
          >Contributions</a
        >
        <a
          class="item"
          v-bind:class="{ active: tabLeft == 3 }"
          @click.prevent="tabLeft = 3"
          >Income</a
        >
        <a
          class="item"
          v-bind:class="{ active: tabLeft == 4 }"
          @click.prevent="tabLeft = 4"
          >Risk</a
        >

        <a
          class="item"
          v-bind:class="{ active: tabLeft == 5 }"
          @click.prevent="tabLeft = 5"
          >Fees</a
        >
      </div>
      <div v-show="tabLeft == 1">
        <div class="ui segment">
          <div class="ui attached message">
            <div class="content">
              <div class="header">Client Details</div>
            </div>
          </div>
          <div class="ui form attached fluid segment">
            <div class="ui field">
              <label>First Name</label>
              <input v-model="cientFirstName" />
            </div>
            <div class="ui field">
              <label>Last Name</label>
              <input v-model="cientLastName" />
            </div>
            <div class="ui field">
              <label>E-Mail</label>
              <input v-model="email" />
            </div>
            <div class="ui field">
              <label>Current Age</label>
              <input v-model="currentAge" @change="updateProjection" />
            </div>
          </div>
        </div>
      </div>

      <div v-show="tabLeft == 2">
        <div class="ui segment">
          <InvestmentInputs
            :accounts="accounts"
            :applyContribution="applyContribution"
            :currentAge="currentAge"
            :contribution="contribution"
            :contributionFrequency="contributionFrequency"
            :contributionGrowth="contributionGrowth"
            :contributionGrowthFrequency="contributionGrowthFrequency"
            :contributionToLast="contributionToLast"
            :contributionStartYear="contributionStartYear"
            @handleInvestmentChanged="handleInvestmentChanged($event)"
          />
        </div>
      </div>
      <div v-show="tabLeft == 3">
        <div class="ui segment">
          <IncomeInput
            @handleIncomeChanged="handleIncomeChanged($event)"
            :currentAge="currentAge"
            :income="income"
            :taxRate="taxRate"
            :incomeGrowth="incomeGrowth"
            :incomeGrowthFrequency="incomeGrowthFrequency"
            :payoutFrequency="payoutFrequency"
            :incomeToLast="incomeToLast"
            :startYear="startYear"
            :accounts="accounts"
            :withdrawalStrategy="withdrawalStrategy"
          />
        </div>
      </div>
      <div v-show="tabLeft == 4">
        <RiskInputs
          :accounts="accounts"
          :riskTolerance="riskTolerance"
          :riskCapacity="riskCapacity"
          :riskProfile="riskProfile"
          :riskPortfolios="riskPortfolios"
          :selectedPortfolio="selectedPortfolio"
          v-on:handleSelected="riskChange($event)"
          v-on:updateProjection="updateProjection($event)"
        />
      </div>
      <div v-show="tabLeft == 5">
        <FeeInputs
          :advisorFee="advisorFee"
          :otherCharges="otherCharges"
          :platformFee="platformFee"
          v-on:handleSelected="feeChange($event)"
        />
      </div>
      <div v-show="tabLeft == 6">
        <GoalInput
          :goalName="goalName"
          :goalDescription="goalDescription"
          :goalHasTarget="goalHasTarget"
          :goalTarget="goalTarget"
          :goalTargetAge="goalTargetAge"
          v-on:handleSelected="goalChange($event)"
          v-on:updateProjection="updateProjection($event)"
        />
      </div>
      <div class="ui padded segment message">
        <sui-button
          v-show="false"
          @click.prevent="editClick"
          type="submit"
          class="primary"
          >Edit</sui-button
        >
        <div is="sui-button-group">
          <sui-button @click.prevent="editClick">Cancel</sui-button>
          <sui-button-or />
          <sui-button positive @click.prevent="saveClick">Save</sui-button>
        </div>

        <router-link class="right floated" to="/clients"
          >Back to All Goals</router-link
        >
      </div>
    </div>
    <div class="eleven wide column" style="padding: 1em 2em 0em 2em">
      <div class="ui small secondary pointing menu">
        <a
          v-if="debug"
          class="item"
          v-bind:class="{ active: tabRight == 1 }"
          @click.prevent="tabRight = 1"
          >Debug Request Response</a
        >
        <a
          v-if="debug"
          class="item"
          v-bind:class="{ active: tabRight == 2 }"
          @click.prevent="tabRight = 2"
          >Debug Accounts</a
        >
        <a
          v-if="debug"
          class="item"
          v-bind:class="{ active: tabRight == 3 }"
          @click.prevent="tabRight = 3"
          >Debug Income</a
        >

        <a
          class="item"
          v-bind:class="{ active: tabRight == 4 }"
          @click.prevent="tabRight = 4"
          >Projections Balances</a
        >

        <a
          class="item"
          v-bind:class="{ active: tabRight == 5 }"
          @click.prevent="tabRight = 5"
          >Projections Income</a
        >
        <a
          class="item"
          v-bind:class="{ active: tabRight == 8 }"
          @click.prevent="tabRight = 8"
          >Portfolio</a
        >
        <a
          class="item"
          v-bind:class="{ active: tabRight == 6 }"
          @click.prevent="tabRight = 6"
          >Historical</a
        >
        <a
          class="item"
          v-bind:class="{ active: tabRight == 7 }"
          @click.prevent="tabRight = 7"
          >Record of Advice</a
        >
      </div>
      <div v-if="tabRight == 1">
        <div class="ui segment">
          <h4>Account Asset Allocation</h4>
          {{ accounts[0].portfolios[0].portfolio.assetAllocation }}
          <h4>ProjectionRequest</h4>
          {{ projectionRequest }}
          <h4>Responses</h4>
          <h5>1. Total Income Targets</h5>
          {{ take(projectionResponse.incomeTargetCfs.incomes, 3) }}
          <h5>2. Total Projections</h5>
          <table class="ui table">
            <tr v-for="p in take(projectionResponse.projections, 5)">
              <td>{{ p.year }}</td>
              <td>{{ p }}</td>
            </tr>
          </table>

          <h5>3. Account specific projections</h5>
        </div>
      </div>
      <div v-if="tabRight == 2">
        <h4>SelectedAccountProjections</h4>
        {{ selectedAccountProjections }}
        <h4>Selected</h4>
      </div>
      <div v-if="tabRight == 3">
        <div class="ui segment">
          <h4>GetIncomeCashFlowRequest</h4>
          Debugging income. Selected withdrwawal strategy =
          {{ getIncomeCashFlowRequest }}
          <h4>Response</h4>
          {{ getIncomeCashFlowResponse }}
        </div>
      </div>

      <div v-if="tabRight == 4">
        <div class="ui segment" :id="colors[1].class">
          <div class="ui row">
            <div class="ui sixteen wide column" v-if="projectionRequest">
              <ChartProjectedBalances
                :colors="colors[1]"
                :chartProjections="selectedAccountProjections"
                :projectionRequest="projectionRequest"
                :applyContribution="applyContribution"
                :show="true"
                v-show="true"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="tabRight == 5">
        <div class="ui segment" :id="colors[1].class">
          <div class="ui row">
            <div class="ui sixteen wide column">
              <ChartProjectedIncome
                :colors="colors[1]"
                :chartProjections="selectedAccountProjections"
                :projectionRequest="projectionRequest"
                :applyContribution="applyContribution"
                :currentAge="currentAge"
                :show="true"
                v-show="true"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="tabRight == 6">
        <div class="ui segment" :id="style">
          <div class="ui row">
            <div class="ui sixteen wide column"></div>
          </div>
          <div class="ui row">
            <div class="ui three wide column">
              <div>
                <span class="ui dividing header">Income</span>
                <div class="ui small statistics">
                  <div class="ui small statistic">
                    <div class="value" v-if="projectionResponse"></div>
                    <div class="label">Current</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tabRight == 8">
        <div class="ui segment" :id="style">
          <div class="ui">
            <div class="ui sixteen column grid">
              <div class="ui row">
                <div class="eight wide column">
                  <ChartBarAaV2
                    :projectionRequest="projectionRequest"
                    :currentAge="currentAge"
                    :chartProjections="selectedAccountProjections"
                    :show="true"
                    v-show="true"
                  />
                </div>
                <div class="eight wide column" v-if="selectedPortfolio">
                  <Positions
                    :selectedPortfolio="selectedPortfolio"
                    :projectionRequest="projectionRequest"
                    :currentAge="currentAge"
                    :show="true"
                    v-show="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import { getAccounts } from "@/utils/accounts.js";

import { getIncome } from "@/utils/income.js";
//import { getPortfolios, AssetAllocation } from "@/utils/portfolios.js";
import {
  getPortfoliosGivenRisk,
  getRiskProfiles,
  getCustomPortfolios,
  getIncomeCashFlowRequest,
  getContribution,
  getProjections,
  saveProjection,
} from "@/gateway";

import { GetProjection, GoalInfo } from "@/dtos";
import numeral from "numeral";

import RiskInputs from "@/components/RiskInputsV2.vue";

import InvestmentInputs from "@/components/InvestmentInputV2.vue";
import FeeInputs from "@/components/FeeInputs.vue";
import IncomeInput from "@/components/IncomeInputV2.vue";
import GoalInput from "@/components/GoalInputV2.vue";

import {
  GetIncomeCashFlowRequest,
  GetContributionCashFlowRequest,
} from "../utils/income";
import ChartProjectedBalances from "@/components/ChartProjectedBalancesV2.vue";

import ChartBarAaV2 from "@/components/ChartBarAaV2.vue";
import Positions from "@/components/PositionsV2.vue";
import ChartProjectedIncome from "@/components/ChartProjectedIncomeV2.vue";
export default {
  name: "home",
  components: {
    IncomeInput,
    GoalInput,
    Positions,
    ChartBarAaV2,
    ChartProjectedBalances,
    ChartProjectedIncome,
    RiskInputs,
    InvestmentInputs,
    FeeInputs,
  },
  computed: {
    selectedAccountProjections: function() {
      // console.log("selectedAccountProjections", this.selected);
      // console.log("this.projectionResponse", this.projectionResponse);
      // if (this.selected.accountId == 0) {
      return this.projectionResponse.projections;
      /* } else {
        return _.filter(this.projectionResponse.accountProjections, {
          accountId: this.selected.accountId
        });
      }*/
    },
  },
  data() {
    return {
      colors: [
        {
          class: "bluebg",
          graph: {
            fontColor: "white",
            axisColor: "white",
            axisGridColor: "grey",
            graphColor: "black",
            averageLineColor: "black",
            bottomScenarioLineColor: "red",
          },
        },
        {
          class: "whitebg",
          graph: {
            fontColor: "grey",
            axisColor: "grey",
            axisGridColor: "white",
            graphColor: "green",
            averageLineColor: "black",
            bottomScenarioLineColor: "red",
          },
        },
      ],
      debug: false,

      // client name
      clientFirstName: "",
      clientLastName: "",
      email: "",

      // goal
      goalName: "Retirement",
      goalDescription: "maintain a living standard throughtout retirement",
      goalHasTarget: false,
      goalTarget: 10000,
      goalTargetAge: 75,
      //
      riskPortfolios: [],
      riskProfile: null,
      riskTolerance: 5,
      riskCapacity: 5,
      selectedPortfolio: null,

      // inputs
      currentAge: 55,
      projectionRequest: null,
      tabLeft: 1,
      tabRight: 1,
      selected: { accountId: 0 },
      accounts: [],
      portfolios: [],
      projectionResponse: [],
      statsResponse: [],

      // fees
      platformFee: 0.8,
      advisorFee: 0.5,
      otherCharges: 0,

      // investments
      getContributionCashFlowRequest: null,
      getContributionCashFlowResponse: null,
      applyContribution: false,
      contribution: 5000,
      contributionFrequency: 12,
      contributionGrowth: 6,
      contributionGrowthFrequency: 1,
      contributionToLast: 65,
      contributionStartYear: 55,

      // income
      getIncomeCashFlowRequest: null,
      getIncomeCashFlowResponse: null,

      income: 10000,
      taxRate: 30,
      incomeGrowth: 6,
      incomeGrowthFrequency: 1,
      payoutFrequency: 12,
      incomeToLast: 93,
      startYear: 65,
      withdrawalStrategy: 0,
    };
  },
  methods: {
    map: function(arr, obj) {
      return _.map(arr, _.partialRight(_.pick, obj));
    },
    flatten: function(arr) {
      return _.flattenDeep(arr);
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    take: function(arr, size) {
      return _.take(arr, size);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.00a");
    },
    clickTab(t) {
      if (this.tab == t) this.tab = 0;
      else this.tab = t;
    },
    async saveClick() {
      let saveClientGoal = {
        clientId: 1122,
        clientGoalv2Id: 0,
        requestObject: this.projectionRequest,
        responseObject: this.projectionResponse,
      };
      // console.log("saveClientGoal", saveClientGoal);
      const response = await saveProjection(saveClientGoal);
    },
    async init() {
      this.accounts = getAccounts();

      //  this.portfolios = getPortfolios();

      // get risk profiles
      var response1 = await getCustomPortfolios();

      if (response1) {
        var response = await getPortfoliosGivenRisk({
          riskProfileId: response1.result[0].riskProfile.id,
        });
        //  console.log("response risk portfolios", response.result);

        this.riskPortfolios = response.result;
        this.riskProfile = response.result[0].riskProfile;
        if (!this.selectedPortfolio) {
          if (
            _.filter(this.riskPortfolios, {
              isWithinRiskNumber: true,
            }).length == 0
          ) {
            this.selectedPortfolio = this.riskPortfolios[0];
          } else {
            this.selectedPortfolio = _.filter(this.riskPortfolios, {
              isWithinRiskNumber: true,
            })[0];
          }
        } else {
          this.selectedPortfolio = _.filter(this.riskPortfolios, {
            id: this.selectedPortfolio.id,
          })[0];
        }
        //console.log("this.selectedPortfolio", this.selectedPortfolio);
        // this.accounts[0].portfolios[0].positions = this.selectedPortfolio.positions;
        this.accounts[0].portfolios[0].portfolio.portfolioName = this.selectedPortfolio.portfolioName;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.localCash = this.selectedPortfolio.localCash;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.localBonds = this.selectedPortfolio.localBonds;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.localEquity = this.selectedPortfolio.localEquity;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.localProperty = this.selectedPortfolio.localProperty;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignCash = this.selectedPortfolio.foreignCash;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignBonds = this.selectedPortfolio.foreignBonds;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignEquity = this.selectedPortfolio.foreignEquity;
        this.accounts[0].portfolios[0].portfolio.assetAllocation.foreignProperty = this.selectedPortfolio.foreignProperty;
        this.updateProjection();
      }
    },
    async handleIncomeChanged(event) {
      // console.log(event);
      this.income = event.income;
      this.taxRate = event.taxRate;
      this.incomeGrowth = event.incomeGrowth;
      this.incomeGrowthFrequency = event.incomeGrowthFrequency;
      this.payoutFrequency = event.payoutFrequency;
      this.incomeToLast = event.incomeToLast;
      this.startYear = event.startYear;
      this.withdrawalStrategy = event.withdrawalStrategy;
      this.updateProjection();
    },
    async handleInvestmentChanged(event) {
      // console.log(event);
      this.applyContribution = event.applyContribution;
      this.contribution = event.contribution;
      this.contributionFrequency = event.contributionFrequency;
      this.contributionGrowth = event.contributionGrowth;
      this.contributionGrowthFrequency = event.contributionGrowthFrequency;
      this.contributionToLast = event.contributionToLast;
      this.contributionStartYear = event.contributionStartYear;
      this.withdrawalStrategy = event.withdrawalStrategy;
      this.updateProjection();
    },
    async updateProjection() {
      this.getIncomeCashFlowRequest = new GetIncomeCashFlowRequest({
        income: this.income,
        incomeGrowth: this.incomeGrowth / 100,
        incomeGrowthFrequency: this.incomeGrowthFrequency,
        payoutFrequency: this.payoutFrequency,
        incomeToLast: this.incomeToLast,
        startYear: this.startYear,
        currentAge: this.currentAge,
        withdrawalStrategy: this.withdrawalStrategy,
      });
      this.getContributionCashFlowRequest = new GetContributionCashFlowRequest({
        applyContribution: this.applyContribution,
        contribution: this.contribution,
        contributionFrequency: this.contributionFrequency,
        contributionGrowth: this.contributionGrowth / 100,
        contributionGrowthFrequency: this.contributionGrowthFrequency,
        contributionToLast: this.contributionToLast,
        contributionStartYear: this.contributionStartYear,
      });
      // this.getIncomeCashFlowResponse = getIncome(this.getIncomeCashFlowRequest);
      let incomeResponse = await getIncomeCashFlowRequest(
        this.getIncomeCashFlowRequest
      );
      let contriResponse = await getContribution(
        this.getContributionCashFlowRequest
      );

      if (incomeResponse) {
        this.getIncomeCashFlowResponse = incomeResponse;
        if (contriResponse) {
          this.getContributionCashFlowResponse = contriResponse;
          /* this.projectionRequest = new ProjectionRequest({
          accounts: this.accounts,
          currentAge: this.currentAge,
          incomeRequest: this.getIncomeCashFlowRequest
        });
        */
          //    console.log(" this.incomeResponse", incomeResponse);
          //   console.log(
          //     " this.getContributionCashFlowResponse",
          //     this.getContributionCashFlowResponse
          //   );
          this.projectionRequest = new GetProjection({
            accounts: this.accounts,
            currentAge: this.currentAge,
            incomeToLastUntilAge: this.incomeToLast,
            incomeCashFlowResponse: incomeResponse,
            contributionCashFlowResponse: contriResponse,
            platformFee: this.platformFee,
            otherCharges: this.otherCharges,
            advisorFee: this.advisorFee,
            goalInfo: new GoalInfo({
              goalName: this.goalName,
              goalDescription: this.goalDescription,
              goalHasTarget: this.goalHasTarget,
              goalTarget: this.goalTarget,
              goalTargetAge: this.goalTargetAge,
            }),
          });
          //this.projectionResponse = calculateProjection(this.projectionRequest);
          //  console.log(" this.projectionRequest", this.projectionRequest);
          const presponse = await getProjections(this.projectionRequest);
          this.projectionResponse = presponse;
        }
      }
    },
    selectChange(event) {
      this.selected = event;
      this.updateProjection();
    },
    riskChange(event) {
      // console.log(event);
      this.accounts = event.accounts;
      this.riskTolerance = event.riskTolerance;
      this.riskCapacity = event.riskCapacity;
      this.riskProfile = event.riskProfile;
      this.selectedPortfolio = event.selectedPortfolio;
      this.riskPortfolios = event.riskPortfolios;

      this.updateProjection();
    },
    feeChange(event) {
      // console.log("feechange", event);
      this.otherCharges = event.otherCharges;
      this.platformFee = event.platformFee;
      this.advisorFee = event.advisorFee;

      this.updateProjection();
    },
    goalChange(event) {
      //  console.log("goalChange", event);
      this.goalName = event.goalName;
      this.goalDescription = event.goalDescription;
      this.goalHasTarget = event.goalHasTarget;
      this.goalTarget = event.goalTarget;
      this.goalTargetAge = event.goalTargetAge;

      this.updateProjection();
    },
    selectDefault() {
      this.selected = this.accounts[0];
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
#bluebg {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(142, 189, 212, 1) 0%,
    rgba(0, 106, 166, 1) 100%
  );
}

#tanbg {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgb(182, 212, 142) 0%,
    rgb(147, 175, 122) 100%
  );
}

#coffeebg {
  background: rgb(2, 0, 36);
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(142, 189, 212, 1) 0%,
    rgba(0, 106, 166, 1) 100%
  );
}
</style>
